/* eslint-disable no-unused-vars */
import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Calendar,
  Video,
  Headphones,
  Users,
  BookOpen,
  Heart,
  DollarSign,
  Sparkles,
  MessageCircle,
  Mic,
  ExternalLink,
  Brain,
  Dumbbell,
  Compass,
  Landmark,
  ArrowRight,
  Check,
  Flame,
  CalendarCheck,
  Quote,
} from 'lucide-react';
import PortalSubPage, { ComingSoonCard } from '../PortalSubPage';
import {
  NEXT_MEETING,
  INTEREST_MAILTO,
  INTEREST_EMAIL,
  CIRCLE_FOCUS,
  CIRCLE_GUEST_SPEAKER,
  CIRCLE_TOPICS,
  CIRCLE_PRICE,
  getReflectionForOffset,
} from '../../data/portalData';

const RESOURCES = [
  {
    title: 'The Reset 2026 Agenda (PDF)',
    desc: 'Full four-day retreat schedule.',
    href: 'https://customer-assets.emergentagent.com/job_analytics-live-1/artifacts/iuaktqnv_TheReset_Panama2026.pdf',
    external: true,
  },
  {
    title: 'The Reset · Full Agenda Page',
    desc: 'Detailed day-by-day, session by session.',
    href: '/agenda',
    external: false,
  },
  {
    title: '"What Keeps You Up At Night?" Survey',
    desc: 'DeWayne\u2019s financial wellness check-in.',
    href: '/survey',
    external: false,
  },
  {
    title: 'Post-Retreat Feedback',
    desc: 'Attendee-only reflection form (post-Panama).',
    href: '/feedback',
    external: false,
  },
];

export function PortalResources() {
  return (
    <PortalSubPage
      eyebrow="Library"
      title={<>Tools &amp; <span className="italic text-[#D4AF37]">reading.</span></>}
      intro="A growing library of PDFs, articles, worksheets, and links to help you continue the work between meetings."
      icon={BookOpen}
    >
      <div className="grid md:grid-cols-2 gap-4">
        {RESOURCES.map((r, i) => {
          const Tag = r.external ? 'a' : 'a';
          const props = r.external
            ? { href: r.href, target: '_blank', rel: 'noopener noreferrer' }
            : { href: r.href };
          return (
            <Tag
              key={i}
              {...props}
              className="rounded-2xl bg-[#111111] border border-white/10 p-6 hover:border-[#D4AF37]/40 transition-all block"
              data-testid={`resource-${i}`}
            >
              <h3 className="font-cormorant text-xl font-medium text-white mb-2 flex items-center gap-2">
                {r.title}
                {r.external && (
                  <ExternalLink className="w-4 h-4 text-zinc-500" />
                )}
              </h3>
              <p className="text-zinc-400 font-manrope text-sm">{r.desc}</p>
            </Tag>
          );
        })}
      </div>
    </PortalSubPage>
  );
}

// ============================================================
// Community
// ============================================================
